import { PricingPlanCard, PricingPlanContainer } from "ui/data-display/PricingPlan/PricingPlanCard";
import { useGetPricingPlansQuery } from "services/common";
import { PricingPlan } from "types";
import { Container } from "ui/layout/Containers";
import { Heading } from "ui/typography/Heading";


export const PricingPlanPage = () => {

    const { data: pricingPlans, isLoading, isError } = useGetPricingPlansQuery();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (isError || !pricingPlans) {
        return <div>Error loading pricing plans.</div>;
    }

    return (
        <Container>
            <Heading>Pricing Plans</Heading>
            <PricingPlanContainer>
                {pricingPlans.map((plan: PricingPlan) => (

                    <PricingPlanCard key={plan.id} plan={plan} onSelect={(id) => console.log(`Selected plan ID: ${id}`)} />
                ))}
            </PricingPlanContainer>
        </Container>
    );
};